import type { App } from 'vue'
import Antd from 'ant-design-vue'

const plugins = [Antd]

// const components = []

export const setupUIFramework = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // components.forEach((component) => {
  //   app.component(component.name!, component)
  // })
}
